<template>
  <div class="right-button-container w-full xl:w-auto grid grid-cols-2 xl:flex gap-2 xl:gap-4 ml-auto justify-end">
    <!-- 추후보완 -->
    <vs-checkbox v-if="useFinishLater" v-model="finishLaterProxy">추후보완</vs-checkbox>

    <!-- 이전 문서 불러오기 -->
    <vs-button v-if="usePrevPost" color="secondary" type="border" @click="$emit('prevPost')" class="hidden xl:block">
      {{ prevPostLabel }}
    </vs-button>

    <!-- 복사하기 -->
    <vs-button v-if="useCopyPost" color="secondary" type="border" @click="$emit('copyPost')" class="hidden xl:block">
      {{ copyPostLabel }}
    </vs-button>

    <!-- 인쇄 -->
    <vs-button v-if="usePrint" color="secondary" @click="$emit('print')" class="hidden xl:block">
      {{ printLabel }}
    </vs-button>

    <!-- 삭제 -->
    <vs-button v-if="useDelete" color="secondary" type="border" @click="$emit('delete')">
      {{ deleteLabel }}
    </vs-button>

    <!-- 목록 / 닫기 -->
    <vs-button v-if="useList" color="secondary" type="border" @click="$emit('moveList')">
      {{ listLabel }}
    </vs-button>
    <vs-button v-if="useClose" color="secondary" type="border" @click="$emit('close')">
      {{ closeLabel }}
    </vs-button>

    <!-- 저장/임시저장/재상신/회수 -->
    <vs-button v-if="useSave" color="secondary" @click="$emit('save')">
      {{ saveLabel }}
    </vs-button>
    <vs-button v-if="useTempsave" color="secondary" @click="$emit('tempsave')">
      {{ tempsaveLabel }}
    </vs-button>
    <vs-button v-if="useReTempsave" color="secondary" @click="$emit('retempsave')">
      {{ reTempsaveLabel }}
    </vs-button>
    <vs-button v-if="useRecall" color="secondary" @click="$emit('recall')">
      {{ recallLabel }}
    </vs-button>
  </div>
</template>

<script>
export default {
  name: "ButtonGroup",
  model: { prop: "value", event: "input" },
  props: {
    // v-model (finishLater)
    value: { type: Boolean, default: false },
    useFinishLater: { type: Boolean, default: false },

    usePrevPost: { type: Boolean, default: false },
    useCopyPost: { type: Boolean, default: false },
    usePrint: { type: Boolean, default: false },
    useDelete: { type: Boolean, default: false },
    useList: { type: Boolean, default: false }, // 목록
    useClose: { type: Boolean, default: false }, // 닫기
    useSave: { type: Boolean, default: false },
    useTempsave: { type: Boolean, default: false },
    useReTempsave: { type: Boolean, default: false },
    useRecall: { type: Boolean, default: false },

    // 라벨
    copyPostLabel: { type: String, default: "복사하기" },
    prevPostLabel: { type: String, default: "이전 문서 불러오기" },
    printLabel: { type: String, default: "인쇄" },
    deleteLabel: { type: String, default: "삭제" },
    listLabel: { type: String, default: "목록" },
    closeLabel: { type: String, default: "닫기" },
    saveLabel: { type: String, default: "저장" },
    tempsaveLabel: { type: String, default: "임시저장" },
    reTempsaveLabel: { type: String, default: "재상신" },
    recallLabel: { type: String, default: "결재문서 회수" },
  },
  computed: {
    finishLaterProxy: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
};
</script>
